import { cva } from 'class-variance-authority';
import { Link } from 'gatsby';
import { twMerge } from 'tailwind-merge';

import type { FooterProps } from '..';
import type { FC } from 'react';

export const footerDisclaimer = cva([
  'border-t-DEFAULT',
  'border-blue-800',
  'pt-8',
  'flex',
  'flex-col',
  'items-start',
  'md:flex-row',
  'md:items-center',
  'gap-4',
  'md:justify-between',
  'xl:justify-start',
]);

interface FooterDisclaimerProps {
  disclaimerMenu: FooterProps['disclaimerMenu'];
}

const FooterDisclaimer: FC<FooterDisclaimerProps> = ({ disclaimerMenu }) => {
  const linkClass =
    'flex items-center gap-4 p-0 text-md font-semibold text-white transition-colors hover:text-primary-200 hover:cursor-pointer relative';

  if (!disclaimerMenu) {
    return null;
  }

  return (
    <div className={twMerge(footerDisclaimer())}>
      {disclaimerMenu?.label && <p className="text-md font-normal text-gray-200">{disclaimerMenu.label}</p>}
      <ul className="flex flex-col items-start gap-4 md:flex-row md:items-center">
        {disclaimerMenu?.links?.map(link => {
          if (!link || link.__typename !== 'ContentfulItemLink' || !link.link) {
            return null;
          }

          return (
            <li key={link.id}>
              <Link to={link.link} className={linkClass}>
                {link.label}
              </Link>
            </li>
          );
        })}
        <li>
          {/** See DG-5893, OneTrust button is configured via GTM */}
          <button
            className={`${linkClass} text-left lg:w-[200px] xl:w-max`}
            onClick={() => window?.OneTrust?.ToggleInfoDisplay()}
          >
            Do Not Sell or Share My Personal Information
          </button>
        </li>
      </ul>
    </div>
  );
};

export default FooterDisclaimer;
